import { Utils } from 'common';
import React, { useEffect, useState } from 'react';
import AccountCommunication from '../utils/AccountCommunication';
import { ActionType } from './ActionType.enum';
import ManagePayment from './ManagePayment.component';

const { CREATE } = ActionType;
const { Session, Util } = Utils;

const completionCallback = ({ status, errorCode, errorDescription }) => {
	const { ShopifyTargetOrigin } = Session.getSettings();

	const shopifySuccess = {
		event: {
			type: 'PaymentMethodAddedSuccess',
			data: {
				storeContext: 'webStore',
			},
		},
	};
	const shopifyError = {
		event: {
			error: {
				message: errorDescription,
				code: errorCode,
			},
		},
	};
	const shopifyData = status ? shopifySuccess : shopifyError;

	Util.postMessage(shopifyData, ShopifyTargetOrigin);
};

const ManagePaymentWrapper = ({ hasHeader, action = CREATE }) => {
	const [payments, setPayments] = useState([]);

	useEffect(() => {
		async function getPaymentAccounts() {
			const response = await AccountCommunication.getPaymentAccounts();

			if (AccountCommunication.isSuccessful(response)) {
				const { PaymentAccounts } = response.data;

				setPayments(PaymentAccounts);
			}
		}

		getPaymentAccounts();
	}, []);

	return (
		<div className="manage-payment-method">
			{hasHeader && <h1 className="manage-payment-header">Manage Payment</h1>}
			<ManagePayment
				data={{
					action,
					callback: completionCallback,
					allAccounts: payments,
				}}
			/>
		</div>
	);
};

export default ManagePaymentWrapper;
